<router-outlet></router-outlet>
<cap-toast [position]="position"></cap-toast>

<!-- App-global outlet for GRIP Link's module-wide live toasts (LinkLiveNotificationsService), so a delivery that
     finishes after you navigate away still toasts. Reuses cap-toast's class names to inherit its severity styling. -->
<p-toast key="link-live-toast" [position]="position" styleClass="cap-toast" [baseZIndex]="5000">
  <ng-template let-message pTemplate="message">
    <div class="d-flex">
      <i class="toast-icon d-flex justify-content-center flex-column fas"
         [ngClass]="{
           'fa-check-circle': message.severity === 'success',
           'fa-exclamation-circle': message.severity === 'warn',
           'fa-times-circle': message.severity === 'error',
           'fa-info-circle': message.severity === 'info'
         }"></i>
      <div class="toast-content">
        <h3 class="toast-summary">{{ message.summary }}</h3>
        <span class="toast-detail">{{ message.detail }}</span>
        <span *ngIf="message.data?.route"
              class="toast-view-link"
              role="button"
              tabindex="0"
              (click)="navigateFromToast(message.data?.route)"
              (keydown.enter)="navigateFromToast(message.data?.route)"
              (keydown.space)="navigateFromToast(message.data?.route)">
          {{ message.data?.linkLabel }}
        </span>
      </div>
    </div>
  </ng-template>
</p-toast>
